var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import $ from "jquery";
import "jquery-ui-bundle";
import "jquery-ui-bundle/jquery-ui.css";
import { removeRteContainerDivFromHTMLString } from "../../utils/removeRteContainerDivFromHTMLString";
import { encodeCharacterEscapedHTML } from "../../utils/encodeCharacterEscapedHTML";
import { Box } from "@mui/system";
export function htmlToSource(selector) {
    return $("<div />").append($(selector).clone()).html();
}
var VTRichTextEditorContent = React.forwardRef(function (_a, ref) {
    var startingHtmlContent = _a.startingHtmlContent, rteId = _a.rteId, viewer = _a.viewer, onChange = _a.onChange, onClick = _a.onClick, sx = _a.sx, onBlur = _a.onBlur;
    var _b = __read(useState(startingHtmlContent), 2), rawHtml = _b[0], setRawHtml = _b[1];
    useEffect(function () {
        setRawHtml(startingHtmlContent);
    }, [startingHtmlContent]);
    function onChangeHandler(shouldEncodeCharacterEscapedHTML) {
        window.setTimeout(function () {
            var richTextEditorHTMLContent = "";
            var $richTextEditorContainer = $("#".concat(rteId));
            richTextEditorHTMLContent = $richTextEditorContainer.html();
            if (shouldEncodeCharacterEscapedHTML) {
                richTextEditorHTMLContent = encodeCharacterEscapedHTML(richTextEditorHTMLContent);
            }
            var domTreeAsArray = $.parseHTML("<div class=\"rte-container\"> ".concat(richTextEditorHTMLContent, " </div>"));
            var $rootSelector = $(domTreeAsArray[0]);
            var marshedHTMLString = htmlToSource($($rootSelector));
            console.log("rich text editor content is:", richTextEditorHTMLContent);
            if (onChange) {
                onChange(marshedHTMLString);
            }
        }, 250);
    }
    return (_jsx(Box, { component: "div", ref: ref, id: rteId, onClick: function (e) {
            if (onClick) {
                onClick(e);
            }
        }, onBlur: function () {
            if (onBlur) {
                onBlur();
            }
        }, onSelect: function (e) { }, onInput: function (e) {
            onChangeHandler(true);
        }, contentEditable: !viewer, sx: __assign({ 
            // overflowY: "scroll",
            width: "100%", height: "100%", padding: "5px", outline: "none" }, sx), 
        // onDrag={() => console.log("dragged")}
        // onMouseUp={() => console.log("mouse up")}
        dangerouslySetInnerHTML: { __html: removeRteContainerDivFromHTMLString(rawHtml) } }));
});
export default VTRichTextEditorContent;
